// Native-shell detection.
//
// The Android build wraps this same web bundle in a Capacitor WebView. Capacitor
// injects `window.Capacitor` before any app code runs, so we can duck-type it
// rather than importing @capacitor/core into the web bundle — the browser build
// stays byte-identical and dependency-free.

interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
}

/** True only inside the packaged Android app, false in every browser. */
export function isNativeApp(): boolean {
  const cap = (globalThis as { Capacitor?: CapacitorGlobal }).Capacitor;
  return cap?.isNativePlatform?.() === true;
}
